<template>
  <ErrorPageTemplate>
    <template v-slot:content>
      <div class="page404">
        <div class="title mb-3">
          {{ $t('errorsPages.404.title') }}
        </div>
        <div class="description mb-5">
          {{ $t('errorsPages.404.description') }}
        </div>
        <div class="desc2 mb-4">
          {{ $t('errorsPages.404.description2') }}
        </div>
        <div class="mb-2">
          <router-link
            :to="homeRoute"
            custom
            v-slot="{ href, navigate }"
            class="text-white font-weight-bold"
          >
            <b-button
              :href="href"
              @click="navigate"
              class="px-4 rounded-xl text-md font-weight-bold line-height-lg"
              variant="primary"
            >
              {{ $t('errorsPages.404.buttonLabel') }}
            </b-button>
          </router-link>
        </div>
        <div>
          <a :href="apUrl" class="back-to-home">{{ $t('errorsPages.404.backToMainPage') }}</a>
        </div>
      </div>
    </template>
  </ErrorPageTemplate>
</template>

<script setup lang="ts">
import ErrorPageTemplate from '@/components/widgets/ErrorPageTemplate.vue'
import type { RouteLocationRaw } from 'vue-router'
import { ref } from 'vue'

const homeRoute = ref<RouteLocationRaw>({ name: 'Home' })
const apUrl = ref<string>(import.meta.env.VITE_APP_AP_URL ?? 'https://akademiaprzyszlosci.org.pl')
</script>
